import { toast } from 'react-toastify';
import { getExternalStore } from 'redux/index';

export function checkStatus(code) {
	const errorCode = code;
	const { dispatch } = getExternalStore().store;

	if (errorCode === 462) {
		toast.error('توکن شما منقضی شده است !', {
			position: toast.POSITION.TOP_CENTER,
			className: 'Toastify-error',
		});
	}

	if (window.location.pathname !== '/auth/login') {
		const signOut = require('redux/slice/login');
		const signOutWallet = require('redux/slice/walletRequestStepOne');

		if (errorCode === 462) {
			if (signOut) {
				dispatch(signOut?.signOut());
			}

			if (signOutWallet) {
				dispatch(signOutWallet?.signOutWallet());
			}
		}
	}
}
